import VueJwtDecode from 'vue-jwt-decode';
import axios from 'axios'
import apiUrl from '../constants'

function configRolesCheck(configRoles) { 
  if(!configRoles) {
    return false;
  }
  configRoles.map(item => item.toLowerCase());

  let accessToken = window.localStorage.getItem('access_token');
  let roles = VueJwtDecode.decode(accessToken);
  roles = roles.resource_access;
  roles = roles["hubops-service"];
  roles = roles.roles;
  roles = roles.map(item => item.toLowerCase());

  return configRoles.some(value => roles.includes(value));
}

function getHubNameByHubId(hubIds, items, objKey) {
  
  axios.post(
    apiUrl.api_url_hubops + 'getHubdetailsFromFMS',
    { facilityIds: hubIds },
    {
      headers: {
        'Content-Type': 'application/json',
        authorization: 'authkey xB84JJ89Hd25'
      }
    }
  )
  .then(resp => {
    if (resp.data.ResultCode !== 100) {
      throw new Error(resp.data.ReturnMessage);
    }

    const facilities = resp.data.ResponseData.facilitiesDetails;
    // build a Map for O(1) lookups
    const nameById = new Map(
      facilities.map(f => [f.facilityId, f.facilityName])
    );

    // single pass over items
    items.forEach(item => {
      const id = item[objKey];
      const name = nameById.get(id);
      if (name) {
        item[objKey] = name;
      }
    });
  })
  .catch(err => {
    console.error('Hub‑name lookup failed:', err);
  });

  // return immediately; Vue will react when items get mutated
  return items;
}

export default {
  configRolesCheck,
  getHubNameByHubId,
}


// WEBPACK FOOTER //
// ./src/utils/index.js